import * as THREE from 'three'
import { OrbitControls } from './Utils/OrbitControls.js'
import {
	MOUSE,
	TOUCH
} from 'three';
import gsap from 'gsap'

export default class Camera {
    constructor(world) {
        this.world = world;
        this.time = this.world.time
        this.sizes = this.world.sizes
        this.scene = this.world.scene
        this.resources = this.world.resources
        this.canvas = this.world.canvas
        this.debug = this.world.debug

        //this.setDebug()
        this.setCamera()
        this.setOrbitControls()
        this.setScroll()
        
        // Mouse
        this.mouse = new THREE.Vector2()

        // Booleans
        this.scroll = true

        // Flare active
        this.flare_2_active = false
        this.flare_3_active = false
        this.flare_4_active = false
        this.flare_5_active = false
        this.flare_6_active = false
        this.flare_7_active = false
        this.flare_8_active = false
    }

    setDebug() {
        // Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Controls')
            this.cameraFolder = this.debug.ui.addFolder('Camera')
            this.debugFolder.close()
            this.cameraFolder.close()
        }
    }

    setCamera() {
        //Camera settings
        this.camera_parameters = {
            near: 0.1,
            far: 60,
            fov: 30,
        }

        //Camera group for mouse parralex
        this.cameraGroup = new THREE.Group()
        this.scene.add(this.cameraGroup)

        //Creating the camera
        this.perspectiveCamera = new THREE.PerspectiveCamera(this.camera_parameters.fov, this.sizes.width / this.sizes.height, this.camera_parameters.near, this.camera_parameters.far)
        this.perspectiveCamera.position.set(0, 24, 0)
        this.perspectiveCamera.lookAt(0,0,0)
        this.cameraGroup.add(this.perspectiveCamera)
    }

    setOrbitControls() {
        //Camera controls
        this.controls = new OrbitControls(this.perspectiveCamera, this.canvas)
        this.controls.enableDamping = true
        this.controls.enableZoom = false
        this.controls.enableRotate = false
	    this.controls.dampingFactor = 0.03
        this.controls.rotateSpeed = 0.3
        this.controls.panSpeed = 1.5

        //Controls input
        this.controls.mouseButtons = { RIGHT: MOUSE.PAN, MIDDLE: MOUSE.PAN, LEFT: MOUSE.PAN };
		this.controls.touches.ONE = THREE.TOUCH.PAN
        this.controls.touches.TWO = THREE.TOUCH.PAN
        this.controls.screenSpacePanning = false

        //zoom range
        this.controls.minDistance = 1.2
        this.controls.maxDistance = 25

        //links/rechts rotation range
        this.controls.minAzimuthAngle = 0
        this.controls.maxAzimuthAngle = 0

        //omhoog/laag rotation range
        this.controls.minPolarAngle = Math.PI / 12
        this.controls.maxPolarAngle = Math.PI / 2.3

        //pan range
        this.perspectiveCameraRange = 8
        this.controls.minPan = new THREE.Vector3( - this.perspectiveCameraRange, - this.perspectiveCameraRange, - this.perspectiveCameraRange - 11)
        this.controls.maxPan = new THREE.Vector3( this.perspectiveCameraRange, this.perspectiveCameraRange, this.perspectiveCameraRange + 4 )

        //Mouse parallex
        this.cursor = {}
        this.cursor.x = 0
        this.cursor.y = 0    

        //Mouse move listener for mouse parallex
        window.addEventListener('mousemove', (event) =>
        {
            this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1
            this.mouse.y = (event.clientY / this.sizes.height) * 2 - 1
        })
        window.addEventListener('touchmove', (event) => {
            const touch = event.touches[0];
            this.mouse.x = (touch.clientX / this.sizes.width) * 2 - 1;
            this.mouse.y = (touch.clientY / this.sizes.height) * 2 - 1;
        }, { passive: true });

    }
 
    setScroll() {
        /////////////////////////////////////////////////////////////////////////////////////////////////
        // Setting up touch event listeners to detect pinch motion (zoom)
        /////////////////////////////////////////////////////////////////////////////////////////////////
        let startDistance = null;
        let currentDistance = null;

        window.addEventListener("touchstart", (event) => {
            if (event.touches.length === 2) {
                const touch1 = event.touches[0];
                const touch2 = event.touches[1];
                startDistance = getDistance(touch1, touch2);
            }
        });

        window.addEventListener("touchend", (event) => {
            startDistance = null;
            currentDistance = null;
        });

        function getDistance(touch1, touch2) {
            const dx = touch2.clientX - touch1.clientX;
            const dy = touch2.clientY - touch1.clientY;
            return Math.sqrt(dx * dx + dy * dy);
        }

        /////////////////////////////////////////////////////////////////////////////////////////////////
        // Zoom event
        /////////////////////////////////////////////////////////////////////////////////////////////////
        function handleZoom(event) {
            if(this.scroll === true){
                //Connecting zoom variable to camera pos y
                let zoom = this.perspectiveCamera.position.y

                /////////////////////////////////////////////////////////////////////////////////////////////////
                // Mouse wheel / touch zoom
                /////////////////////////////////////////////////////////////////////////////////////////////////
                if (event.type === "wheel") {

                    if (!scrollWheelEnabled) {
                        event.preventDefault()
                    }

                    zoom += event.deltaY * 0.07
                
                } else if (event.touches.length === 2) {
                    if (!scrollWheelEnabled) {
                        event.preventDefault()
                    }

                    //naming the touches
                    const touch1 = event.touches[0]
                    const touch2 = event.touches[1]

                    //calculating the distance of the pinch
                    currentDistance = getDistance(touch1, touch2)
                    const deltaDistance = currentDistance - startDistance

                    //assinging the touch move to zoom
                    zoom += deltaDistance * - 0.15
                }

                //Mapping the zoom to the y position range of the camera
                zoom = Math.min(Math.max(2, zoom), 24)

                //animating the camera y based on the zoom
                gsap.to(this.perspectiveCamera.position, {ease: "circOut", y: zoom, duration: 1})
                
                //updating the camera
                this.perspectiveCamera.updateProjectionMatrix()

                //removing the text element
                this.world.world.route.div_text.innerHTML = ''
            }

            if(this.scroll === false && (event.type === "wheel" || event.touches.length === 2)){
                //disable b24 follow
                this.world.world.raycast.b24_follow = false
                this.world.world.raycast.spitfire_follow = false

                //enable orbit controls
                this.controls.enabled = true
                this.world.world.raycast.clickable = false

                //resetting the camera angle
                gsap.to( this.controls, { duration: 3, ease: 'power1.InOut', maxDistance: 24})
                gsap.to( this.controls, { duration: 3, ease: 'power1.InOut', maxPolarAngle: Math.PI / 2.3})
                gsap.to( this.controls, { duration: 3, ease: 'power1.InOut', minPolarAngle: Math.PI / 12})
                
                //setting camera rotation
                gsap.to( this.controls, { duration: 3, ease: 'power1.InOut', minAzimuthAngle: 0, maxAzimuthAngle: 0})

                //fully zooming out the camera
                gsap.to(this.perspectiveCamera.position, {ease: "circOut", y: 24, duration: 3})

                //activating scroll en poi hover wanneer animatie klaar is
                setTimeout(() => {
                    this.scroll = true
                    this.world.world.raycast.clickable = true
                    this.world.world.route.badge6Top.visible = true
                    this.world.world.route.badge6Bottom.visible = true
                }, 3000)

                //Completely remove POI text
                this.world.world.raycast.poi_text_ani.kill()
                gsap.to( ".text_div", {duration: 0,  opacity: 0 })
                this.world.world.route.div_text.innerHTML = ''

                //Stop all poi audio and play zoom out sound
                if(this.world.world.audio.poi_1_sound.isPlaying === true){ 
                    this.poi_1_audio_out = this.world.world.audio.poi_1_audio_out
                    this.poi_1_sound = this.world.world.audio.poi_1_sound
                    this.poi_1_audio_out.to(this.poi_1_sound.gain.gain, 2, { value: 0 })
                    this.poi_1_audio_out.play()
                }
                if(this.world.world.audio.poi_2_sound.isPlaying === true){
                    this.poi_2_audio_out = this.world.world.audio.poi_2_audio_out
                    this.poi_2_sound = this.world.world.audio.poi_2_sound
                    this.poi_2_audio_out.to(this.poi_2_sound.gain.gain, 2, { value: 0 })
                    this.poi_2_audio_out.play()
                }
                if(this.world.world.audio.poi_3_sound.isPlaying === true){ 
                    this.poi_3_audio_out = this.world.world.audio.poi_3_audio_out
                    this.poi_3_sound = this.world.world.audio.poi_3_sound
                    this.poi_3_audio_out.to(this.poi_3_sound.gain.gain, 2, { value: 0 })
                    this.poi_3_audio_out.play()
                }
                if(this.world.world.audio.poi_4_sound.isPlaying === true){ 
                    this.poi_4_audio_out = this.world.world.audio.poi_4_audio_out
                    this.poi_4_sound = this.world.world.audio.poi_4_sound
                    this.poi_4_audio_out.to(this.poi_4_sound.gain.gain, 2, { value: 0 })
                    this.poi_4_audio_out.play()
                }
                if(this.world.world.audio.poi_5_sound.isPlaying === true){ 
                    this.poi_5_audio_out = this.world.world.audio.poi_5_audio_out
                    this.poi_5_sound = this.world.world.audio.poi_5_sound
                    this.poi_5_audio_out.to(this.poi_5_sound.gain.gain, 2, { value: 0 })
                    this.poi_5_audio_out.play()
                }
                if(this.world.world.audio.poi_6_sound.isPlaying === true){ 
                    this.poi_6_audio_out = this.world.world.audio.poi_6_audio_out
                    this.poi_6_sound = this.world.world.audio.poi_6_sound
                    this.poi_6_audio_out.to(this.poi_6_sound.gain.gain, 2, { value: 0 })
                    this.poi_6_audio_out.play()
                }
                if(this.world.world.audio.poi_7_sound.isPlaying === true){ 
                    this.poi_7_audio_out = this.world.world.audio.poi_7_audio_out
                    this.poi_7_sound = this.world.world.audio.poi_7_sound
                    this.poi_7_audio_out.to(this.poi_7_sound.gain.gain, 2, { value: 0 })
                    this.poi_7_audio_out.play()
                }
                if(this.world.world.audio.poi_8_sound.isPlaying === true){ 
                    this.poi_8_audio_out = this.world.world.audio.poi_8_audio_out
                    this.poi_8_sound = this.world.world.audio.poi_8_sound
                    this.poi_8_audio_out.to(this.poi_8_sound.gain.gain, 2, { value: 0 })
                    this.poi_8_audio_out.play()
                }
                if(this.world.world.audio.poi_zoom_out_sound.isPlaying === true){ 
                    this.world.world.audio.poi_zoom_out_sound.stop()
                }
                this.world.world.audio.poi_zoom_out_sound.play()

                /////////////////////////////////////////////////////////////////////////////////////////////////
                // Elements to be used for scroll events
                /////////////////////////////////////////////////////////////////////////////////////////////////
        
                //////////////////////////////////////////////
                this.flare = this.world.world.environment.light
                this.flareTexture = this.world.world.environment.flare
                //////////////////////////////////////////////
                this.color1Mix = this.world.world.route.uniforms1.transition1
                this.color2Mix = this.world.world.route.uniforms2.transition1
                this.color3Mix = this.world.world.route.uniforms3.transition1
                this.color4Mix = this.world.world.route.uniforms4.transition1
                this.color5Mix = this.world.world.route.uniforms5.transition1
                this.color6Mix = this.world.world.route.uniforms6.transition1
                this.color7Mix = this.world.world.route.uniforms7.transition1
                this.color8Mix = this.world.world.route.uniforms8.transition1
                //////////////////////////////////////////////
                this.route_1 = this.world.world.route.route_1
                this.route_2 = this.world.world.route.route_2
                this.route_3 = this.world.world.route.route_3
                this.route_4 = this.world.world.route.route_4
                this.route_5 = this.world.world.route.route_5
                this.route_6 = this.world.world.route.route_6
                this.route_7 = this.world.world.route.route_7
                //////////////////////////////////////////////
                this.arnhem_rand = this.world.world.route.arnhem_rand
                this.ede_rand = this.world.world.route.ede_rand
                this.apeldoorn_rand = this.world.world.route.apeldoorn_rand
                this.uddel_rand = this.world.world.route.uddel_rand
                this.barneveld_rand = this.world.world.route.barneveld_rand
                this.wageningen_rand = this.world.world.route.wageningen_rand
                this.renkum_rand = this.world.world.route.renkum_rand
                this.nijmegen_rand = this.world.world.route.nijmegen_rand
                //////////////////////////////////////////////
            
                /////////////////////////////////////////////////////////////////////////////////////////////////
                // POI event animations
                /////////////////////////////////////////////////////////////////////////////////////////////////

                //POI 1 > 2 on zoom out
                if(this.world.world.raycast.poi2Active === true && this.flare_2_active === false){
                    //setting the flare to active
                    this.flare_2_active = true

                    //animating route 1 > 2
                    gsap.to( this.color2Mix, { duration: 2, ease: 'power2.out', value: 0, delay: 1.5 })
                    gsap.to( this.route_1.material.map.offset, { duration: 10, ease: 'power2.out', x: -1 })
                    gsap.to( this.arnhem_rand.position, { duration: 3, ease: 'power2.out', y: 0 })

                    var tl1 = gsap.timeline()
                    //hiding the flare
                    tl1.to( this.flare.position, { duration: 4, ease: 'power2.out', y: 0 })
                    tl1.to( this.flare, { duration: 1, ease: 'power2.out', intensity: 0 }, "<")
                    tl1.to( this.flareTexture.scale, { duration: 4, ease: 'power2.out', x: 0, y: 0, z: 0 }, "<")

                    setTimeout(() => {
                        //flare shot sound
                        this.flare_shot_sound = this.world.world.audio.flare_shot_sound
                        this.flare_shot_sound.play()
                    }, 3500)    

                    //re-positioning the flare
                    tl1.to( this.flare.position, { duration: 0, ease: 'power2.out', x: -4.5, z: -1.4 })

                    //showing the flare
                    tl1.to( this.flare.position, { duration: 4, ease: 'power2.out', y: 1.5 }, "<<")
                    tl1.to( this.flare, { delay: 1, duration: 1, ease: 'power2.out', intensity: 150 }, "<<")
                    tl1.to( this.flareTexture.scale, { duration: 4, ease: 'power2.out', x: 1, y: 1, z: 1 }, "<<")
                }
                //POI 2 > 3 on zoom out
                if(this.world.world.raycast.poi3Active === true && this.flare_3_active === false){
                    //setting the flare to active
                    this.flare_3_active = true

                    //animating route 2 > 3
                    gsap.to( this.color3Mix, { duration: 2, ease: 'power2.out', value: 0, delay: 1.5 })
                    gsap.to( this.route_2.material.map.offset, { duration: 10, ease: 'power2.out', x: -1 })
                    gsap.to( this.ede_rand.position, { duration: 3, ease: 'power2.out', y: 0 })

                    var tl1 = gsap.timeline()
                    //hiding the flare
                    tl1.to( this.flare.position, { duration: 4, ease: 'power2.out', y: 0 })
                    tl1.to( this.flare, { duration: 1, ease: 'power2.out', intensity: 0 }, "<")
                    tl1.to( this.flareTexture.scale, { duration: 4, ease: 'power2.out', x: 0, y: 0, z: 0 }, "<")

                    setTimeout(() => {
                        //flare shot sound
                        this.flare_shot_sound = this.world.world.audio.flare_shot_sound
                        this.flare_shot_sound.play()
                    }, 3500)    
                    //re-positioning the flare
                    tl1.to( this.flare.position, { duration: 0, ease: 'power2.out', x: 5.1, z: -13 })

                    //showing the flare
                    tl1.to( this.flare.position, { duration: 4, ease: 'power2.out', y: 1.5 }, "<<")
                    tl1.to( this.flare, { delay: 1, duration: 1, ease: 'power2.out', intensity: 150 }, "<<")
                    tl1.to( this.flareTexture.scale, { duration: 4, ease: 'power2.out', x: 1, y: 1, z: 1 }, "<<")
                }
                //POI 3 > 4 on zoom out
                if(this.world.world.raycast.poi4Active === true && this.flare_4_active === false){
                    //setting the flare to active
                    this.flare_4_active = true

                    //animating route 3 > 4
                    gsap.to( this.color4Mix, { duration: 2, ease: 'power2.out', value: 0, delay: 1.5 })
                    gsap.to( this.route_3.material.map.offset, { duration: 10, ease: 'power2.out', x: -1 })
                    gsap.to( this.apeldoorn_rand.position, { duration: 3, ease: 'power2.out', y: 0 })

                    var tl1 = gsap.timeline()
                    //hiding the flare
                    tl1.to( this.flare.position, { duration: 4, ease: 'power2.out', y: 0 })
                    tl1.to( this.flare, { duration: 1, ease: 'power2.out', intensity: 0 }, "<")
                    tl1.to( this.flareTexture.scale, { duration: 4, ease: 'power2.out', x: 0, y: 0, z: 0 }, "<")

                    setTimeout(() => {
                        //flare shot sound
                        this.flare_shot_sound = this.world.world.audio.flare_shot_sound
                        this.flare_shot_sound.play()
                    }, 3500)    
                    //re-positioning the flare
                    tl1.to( this.flare.position, { duration: 0, ease: 'power2.out', x: 1, z: -13.5 })

                    //showing the flare
                    tl1.to( this.flare.position, { duration: 4, ease: 'power2.out', y: 1.5 }, "<<")
                    tl1.to( this.flare, { delay: 1, duration: 1, ease: 'power2.out', intensity: 150 }, "<<")
                    tl1.to( this.flareTexture.scale, { duration: 4, ease: 'power2.out', x: 1, y: 1, z: 1 }, "<<")
                }
                //POI 4 > 5 on zoom out
                if(this.world.world.raycast.poi5Active === true && this.flare_5_active === false){
                    //setting the flare to active
                    this.flare_5_active = true

                    //animating route 4 > 5
                    gsap.to( this.color5Mix, { duration: 2, ease: 'power2.out', value: 0, delay: 1.5 })
                    gsap.to( this.route_4.material.map.offset, { duration: 10, ease: 'power2.out', x: -1 })
                    gsap.to( this.uddel_rand.position, { duration: 3, ease: 'power2.out', y: 0 })

                    var tl1 = gsap.timeline()
                    //hiding the flare
                    tl1.to( this.flare.position, { duration: 4, ease: 'power2.out', y: 0 })
                    tl1.to( this.flare, { duration: 1, ease: 'power2.out', intensity: 0 }, "<")
                    tl1.to( this.flareTexture.scale, { duration: 4, ease: 'power2.out', x: 0, y: 0, z: 0 }, "<")

                    setTimeout(() => {
                        //flare shot sound
                        this.flare_shot_sound = this.world.world.audio.flare_shot_sound
                        this.flare_shot_sound.play()
                    }, 3500)    
                    //re-positioning the flare
                    tl1.to( this.flare.position, { duration: 0, ease: 'power2.out', x: -6.7, z: -6.7 })

                    //showing the flare
                    tl1.to( this.flare.position, { duration: 4, ease: 'power2.out', y: 1.5 }, "<<")
                    tl1.to( this.flare, { delay: 1, duration: 1, ease: 'power2.out', intensity: 150 }, "<<")
                    tl1.to( this.flareTexture.scale, { duration: 4, ease: 'power2.out', x: 1, y: 1, z: 1 }, "<<")
                }
                //POI 5 > 6 on zoom out
                if(this.world.world.raycast.poi6Active === true && this.flare_6_active === false){
                    //setting the flare to active
                    this.flare_6_active = true

                    //animating route 5 > 6
                    gsap.to( this.color6Mix, { duration: 2, ease: 'power2.out', value: 0, delay: 1.5 })
                    gsap.to( this.route_5.material.map.offset, { duration: 10, ease: 'power2.out', x: -1 })
                    gsap.to( this.barneveld_rand.position, { duration: 3, ease: 'power2.out', y: 0 })

                    var tl1 = gsap.timeline()
                    //hiding the flare
                    tl1.to( this.flare.position, { duration: 4, ease: 'power2.out', y: 0 })
                    tl1.to( this.flare, { duration: 1, ease: 'power2.out', intensity: 0 }, "<")
                    tl1.to( this.flareTexture.scale, { duration: 4, ease: 'power2.out', x: 0, y: 0, z: 0 }, "<")

                    setTimeout(() => {
                        //flare shot sound
                        this.flare_shot_sound = this.world.world.audio.flare_shot_sound
                        this.flare_shot_sound.play()
                    }, 3500)    
                    //re-positioning the flare
                    tl1.to( this.flare.position, { duration: 0, ease: 'power2.out', x: -4, z: 3 })
  
                    //showing the flare
                    tl1.to( this.flare.position, { duration: 4, ease: 'power2.out', y: 1.5 }, "<<")
                    tl1.to( this.flare, { delay: 1, duration: 1, ease: 'power2.out', intensity: 150 }, "<<")
                    tl1.to( this.flareTexture.scale, { duration: 4, ease: 'power2.out', x: 1, y: 1, z: 1 }, "<<")
                }
                //POI 6 > 7 on zoom out
                if(this.world.world.raycast.poi7Active === true && this.flare_7_active === false){              
                    //setting the flare to active
                    this.flare_7_active = true

                    //animating route 6 > 7
                    gsap.to( this.color7Mix, { duration: 2, ease: 'power2.out', value: 0, delay: 1.5 })
                    gsap.to( this.route_6.material.map.offset, { duration: 10, ease: 'power2.out', x: -1 })
                    gsap.to( this.wageningen_rand.position, { duration: 3, ease: 'power2.out', y: 0 })

                    var tl1 = gsap.timeline()
                    //hiding the flare
                    tl1.to( this.flare.position, { duration: 4, ease: 'power2.out', y: 0 })
                    tl1.to( this.flare, { duration: 1, ease: 'power2.out', intensity: 0 }, "<")
                    tl1.to( this.flareTexture.scale, { duration: 4, ease: 'power2.out', x: 0, y: 0, z: 0 }, "<")
 
                    setTimeout(() => {
                        //flare shot sound
                        this.flare_shot_sound = this.world.world.audio.flare_shot_sound
                        this.flare_shot_sound.play()
                    }, 3500)  
                    //re-positioning the flare
                    tl1.to( this.flare.position, { duration: 0, ease: 'power2.out', x: -1.2, z: 3 })
       
                    //showing the flare
                    tl1.to( this.flare.position, { duration: 4, ease: 'power2.out', y: 1.5 }, "<<")
                    tl1.to( this.flare, { delay: 1, duration: 1, ease: 'power2.out', intensity: 150 }, "<<")
                    tl1.to( this.flareTexture.scale, { duration: 4, ease: 'power2.out', x: 1, y: 1, z: 1 }, "<<")
                }
                //POI 7 > 8 on zoom out
                if(this.world.world.raycast.poi8Active === true && this.flare_8_active === false){
                    //setting the flare to active
                    this.flare_8_active = true

                    //animating route 7 > 8
                    gsap.to( this.color8Mix, { duration: 2, ease: 'power2.out', value: 0, delay: 1.5 })
                    gsap.to( this.route_7.material.map.offset, { duration: 10, ease: 'power2.out', x: -1 })
                    gsap.to( this.renkum_rand.position, { duration: 3, ease: 'power2.out', y: 0 })

                    var tl1 = gsap.timeline()
                    //hiding the flare
                    tl1.to( this.flare.position, { duration: 4, ease: 'power2.out', y: 0 })
                    tl1.to( this.flare, { duration: 1, ease: 'power2.out', intensity: 0 }, "<")
                    tl1.to( this.flareTexture.scale, { duration: 4, ease: 'power2.out', x: 0, y: 0, z: 0 }, "<")

                    setTimeout(() => {
                        //flare shot sound
                        this.flare_shot_sound = this.world.world.audio.flare_shot_sound
                        this.flare_shot_sound.play()
                    }, 3500)    
                    //re-positioning the flare
                    tl1.to( this.flare.position, { duration: 0, ease: 'power2.out', x: 3, z: 11 })
       
                    //showing the flare
                    tl1.to( this.flare.position, { duration: 4, ease: 'power2.out', y: 1.5 }, "<<")
                    tl1.to( this.flare, { delay: 1, duration: 1, ease: 'power2.out', intensity: 150 }, "<<")
                    tl1.to( this.flareTexture.scale, { duration: 4, ease: 'power2.out', x: 1, y: 1, z: 1 }, "<<")
                }
            }
        }

        //Calling the event for zoom
        window.addEventListener("wheel", handleZoom.bind(this), { passive: false });
        window.addEventListener("touchmove", handleZoom.bind(this), { passive: false });
    }

    resize() {
        this.perspectiveCamera.aspect = this.sizes.width / this.sizes.height
        this.perspectiveCamera.updateProjectionMatrix()
    }

    update() {
        //orbitcontrols update
        this.controls.update()

        //camera mouse parallex
        const parallexX = - this.mouse.x
        const parallexY = - this.mouse.y

        //mapping the mouse pos
        var x_map = gsap.utils.mapRange(-1, 1, -0.01, 0.01, parallexX)
        var y_map = gsap.utils.mapRange(-1, 1, -0.01, 0.01, parallexY)

        //adding mouse pos to camera rotation
        this.cameraGroup.rotation.x += (y_map - this.cameraGroup.rotation.x) * 0.05
        this.cameraGroup.rotation.y += (x_map - this.cameraGroup.rotation.y) * 0.05

        //camera y position
        var y_zoom = this.perspectiveCamera.position.y;

        //mapping camera far
        var far_map = gsap.utils.mapRange(2, 24, 10, 60, y_zoom)
        this.perspectiveCamera.far = far_map

        //mapping camera fov
        var fov_map = gsap.utils.mapRange(2, 24, 30, 65, y_zoom)
        this.perspectiveCamera.fov = fov_map

        //updating the camera changes
        this.perspectiveCamera.updateProjectionMatrix()
    }
}